import React, { Component } from 'react';
import Header from '../layout/Header';

export class Our_expert extends Component {
    render() {
        return (
            <div className="site-main">
                <Header />
                {/* page-title */}
                <div className="ttm-page-title-row-02">
                    <div className="container-xl">
                    <div className="row">
                        <div className="col-md-12"> 
                        <div className="title-box">
                            <div className="page-title-heading">
                            <h1 className="title">Our Experts</h1>
                            </div>{/* /.page-title-captions */}
                            <div className="breadcrumb-wrapper">
                            <span>
                                <a title="Homepage" href={process.env.PUBLIC_URL + '/'}>Home</a>
                            </span>
                            <span className="ttm-bread-sep">&nbsp; : : &nbsp;</span>
                            <span>Our Experts</span>
                            </div>  
                        </div>
                        </div>{/* /.col-md-12 */}  
                    </div>{/* /.row */}  
                    </div>{/* /.container */}                      
                </div>
                {/* page-title end*/}
                
                <section class="ttm-row team-section clearfix">
                    <div class="container">
                        <div class="row align-items-center">
                            <div class="col-xl-8 col-lg-6 col-md-12 col-sm-12">
                                <div class="blog-title text-right">
                                    <div class="section-title style2">
                                        <div class="title-header">
                                        <h2>Expert</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-4 col-lg-6 col-md-12 col-sm-12 "> 
                                <div class="process-desc process-desc1">
                                    <p class="desc-text">Web designing in a powerful way of just not a profession, how in a passion for our Company. We have a to the idea.</p>
                                </div>
                            </div>
                        </div>
                        <div class="row align-items-center res-991-mt-0">
                            <div class="col-xl-4 col-lg-3 col-md-12 col-sm-12 blog-sm">
                                <div class="blog-title text-right">
                                    <a class="ttm-btn ttm-btn-size-md ttm-btn-shape-round ttm-btn-style-fill ttm-btn-color-gradiant" href={process.env.PUBLIC_URL + '/Team_detail'}>Contact Team!</a>
                                </div>
                            </div>
                            <div class="col-xl-8 col-lg-9 col-md-12 col-sm-12 "> 
                                <div class="section-title style2 pl-20 res-991-pl-0">
                                    <div class="title-header">
                                    <h2>team</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row res-991-mt-0">
                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div class="featured-imagebox-team style1">
                                    <div class="image-box-overlay"></div>
                                    <div class="imagebox-team-thumbnail">
                                        <img width="417" height="503" class="img-fluid" src="images/team/team01.jpg" loading="lazy" alt="team-img" />
                                    </div>
                                    <div class="imagebox-team-content">
                                        <div class="imagebox-team-social">
                                            <ul class="team-social-icons">
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-facebook-f"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-twitter"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-linkedin-in"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-google-plus-g"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="imagebox-team-title">
                                            <div class="imagebox-team-category">Product Analyst</div>
                                            <h3 class="imagebox-team-heading">
                                            <a href={process.env.PUBLIC_URL + '/Team_detail'} class="team-heading-link">Andrew Bon</a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div class="featured-imagebox-team style1">
                                    <div class="image-box-overlay"></div>
                                    <div class="imagebox-team-thumbnail">
                                        <img width="417" height="503" class="img-fluid" src="images/team/team02.jpg" loading="lazy" alt="team-img" />
                                    </div>
                                    <div class="imagebox-team-content">
                                        <div class="imagebox-team-social">
                                        <ul class="team-social-icons">
                                            <li class="team-social-icon-item">
                                                <a href="#" class="team-social-link"><i class="fab fa-facebook-f"></i></a>
                                            </li>
                                            <li class="team-social-icon-item">
                                                <a href="#" class="team-social-link"><i class="fab fa-twitter"></i></a>
                                            </li>
                                            <li class="team-social-icon-item">
                                                <a href="#" class="team-social-link"><i class="fab fa-linkedin-in"></i></a>
                                            </li>
                                            <li class="team-social-icon-item">
                                                <a href="#" class="team-social-link"><i class="fab fa-google-plus-g"></i></a>
                                            </li>
                                        </ul>
                                        </div>
                                        <div class="imagebox-team-title">
                                            <div class="imagebox-team-category">IT Associative</div>
                                            <h3 class="imagebox-team-heading">
                                            <a href={process.env.PUBLIC_URL + '/Team_detail'} class="team-heading-link">John Bruce</a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div class="featured-imagebox-team style1">
                                    <div class="image-box-overlay"></div>
                                    <div class="imagebox-team-thumbnail">
                                        <img width="417" height="503" class="img-fluid" src="images/team/team03.jpg" loading="lazy" alt="team-img" />
                                    </div>
                                    <div class="imagebox-team-content">
                                        <div class="imagebox-team-social">
                                            <ul class="team-social-icons">
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-facebook-f"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-twitter"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-linkedin-in"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-google-plus-g"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="imagebox-team-title">
                                            <div class="imagebox-team-category">IT Service Officer</div>
                                            <h3 class="imagebox-team-heading">
                                            <a href={process.env.PUBLIC_URL + '/Team_detail'} class="team-heading-link">Jennifer Garcia</a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div class="featured-imagebox-team style1">
                                    <div class="image-box-overlay"></div>
                                    <div class="imagebox-team-thumbnail">
                                        <img width="417" height="503" class="img-fluid" src="images/team/team04.jpg" loading="lazy" alt="team-img" />
                                    </div>
                                    <div class="imagebox-team-content">
                                        <div class="imagebox-team-social">
                                            <ul class="team-social-icons">
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-facebook-f"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-twitter"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-linkedin-in"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-google-plus-g"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="imagebox-team-title">
                                            <div class="imagebox-team-category">Project Manager</div>
                                            <h3 class="imagebox-team-heading">
                                            <a href={process.env.PUBLIC_URL + '/Team_detail'} class="team-heading-link">Jessic Ethan</a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div class="featured-imagebox-team style1">
                                    <div class="image-box-overlay"></div>
                                    <div class="imagebox-team-thumbnail">
                                        <img width="417" height="503" class="img-fluid" src="images/team/team05.jpg" loading="lazy" alt="team-img" />
                                    </div>
                                    <div class="imagebox-team-content">
                                        <div class="imagebox-team-social">
                                            <ul class="team-social-icons">
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-facebook-f"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-twitter"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-linkedin-in"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-google-plus-g"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="imagebox-team-title">
                                            <div class="imagebox-team-category">Web Designer</div>
                                            <h3 class="imagebox-team-heading">
                                            <a href={process.env.PUBLIC_URL + '/Team_detail'} class="team-heading-link">Robert Liam</a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div class="featured-imagebox-team style1">
                                    <div class="image-box-overlay"></div>
                                    <div class="imagebox-team-thumbnail">
                                        <img width="417" height="503" class="img-fluid" src="images/team/team06.jpg" loading="lazy" alt="team-img" />
                                    </div>
                                    <div class="imagebox-team-content">
                                        <div class="imagebox-team-social">
                                            <ul class="team-social-icons">
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-facebook-f"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-twitter"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-linkedin-in"></i></a>
                                                </li>
                                                <li class="team-social-icon-item">
                                                    <a href="#" class="team-social-link"><i class="fab fa-google-plus-g"></i></a>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="imagebox-team-title">
                                            <div class="imagebox-team-category">Consultant Officer</div>
                                            <h3 class="imagebox-team-heading">
                                            <a href={process.env.PUBLIC_URL + '/Team_detail'} class="team-heading-link">Amanda Brown</a>
                                            </h3>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            )
    }
}


export default Our_expert;